import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b2d4fda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "primary-container" }
const _hoisted_2 = { class: "flex justify-between mt-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1 6L5.75 1.25M1 6L5.75 10.75M1 6L12.0833 6",
    stroke: "#344054",
    "stroke-width": "1.58333",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 animate-spin",
  viewBox: "0 0 100 100"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current opacity-40",
    cx: "50",
    cy: "50",
    r: "40"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current",
    "stroke-dasharray": "250",
    "stroke-dashoffset": "210",
    cx: "50",
    cy: "50",
    r: "40"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 animate-spin",
  viewBox: "0 0 100 100"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current opacity-40",
    cx: "50",
    cy: "50",
    r: "40"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current",
    "stroke-dasharray": "250",
    "stroke-dashoffset": "210",
    cx: "50",
    cy: "50",
    r: "40"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  class: "form-card-tabs-container"
}
const _hoisted_11 = { class: "columns-2 mt-4" }
const _hoisted_12 = { class: "columns-2 mt-4 flex gap-4 items-end" }
const _hoisted_13 = { class: "text-[#344054] font-medium text-sm" }
const _hoisted_14 = { class: "relative" }
const _hoisted_15 = { class: "columns-2 mt-4" }
const _hoisted_16 = { class: "columns-2 mt-4" }
const _hoisted_17 = { class: "text-dark-grey font-semibold text-xl mt-12 mb-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_20 = {
  key: 0,
  class: "relative top-2"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { class: "flex-shrink-0" }
const _hoisted_24 = { class: "ml-3" }
const _hoisted_25 = { class: "ml-auto pl-3" }
const _hoisted_26 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_27 = { class: "sr-only" }
const _hoisted_28 = {
  key: 1,
  class: "flex items-center justify-center py-8 bg-white p-6"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 animate-spin",
  viewBox: "0 0 100 100"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current opacity-40",
    cx: "50",
    cy: "50",
    r: "40"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    fill: "none",
    "stroke-width": "10",
    class: "stroke-current",
    "stroke-dasharray": "250",
    "stroke-dashoffset": "210",
    cx: "50",
    cy: "50",
    r: "40"
  })
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "flex justify-between items-center mt-4" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0001 4.16663V15.8333M4.16675 9.99996H15.8334",
    stroke: "#475467",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_35 = { class: "font-semibold text-sm color-[#475467]" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.0001 4.16663V15.8333M4.16675 9.99996H15.8334",
    stroke: "#475467",
    "stroke-width": "1.66667",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_37 = { class: "font-semibold text-sm color-[#475467]" }
const _hoisted_38 = ["onClick", "disabled"]
const _hoisted_39 = { class: "font-semibold text-sm" }
const _hoisted_40 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 0,
  class: "pt-[10px]"
}
const _hoisted_43 = { class: "absolute right-[-2rem] top-8" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "flex justify-end mt-4" }
const _hoisted_46 = ["onClick", "disabled"]
const _hoisted_47 = { class: "font-semibold text-sm" }
const _hoisted_48 = {
  key: 0,
  class: "flex items-center justify-center gap-x-1"
}
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 0,
  class: "rounded-md bg-green-50 p-4 mt-5"
}
const _hoisted_51 = { class: "flex" }
const _hoisted_52 = { class: "flex-shrink-0" }
const _hoisted_53 = { class: "ml-3" }
const _hoisted_54 = { class: "text-sm font-medium text-green-800" }
const _hoisted_55 = { class: "ml-auto pl-3" }
const _hoisted_56 = { class: "-mx-1.5 -my-1.5" }
const _hoisted_57 = { class: "sr-only" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_59 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_60 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "calendar-icon",
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#FDA29B",
      "fill-opacity": "0.25"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M22.5005 36.4279C22.5005 29.9073 22.5005 26.646 24.5271 24.6212C26.5519 22.5946 29.8131 22.5946 36.3338 22.5946H43.2505C49.7712 22.5946 53.0324 22.5946 55.0572 24.6212C57.0838 26.646 57.0838 29.9073 57.0838 36.4279V39.8863C57.0838 46.407 57.0838 49.6682 55.0572 51.693C53.0324 53.7196 49.7712 53.7196 43.2505 53.7196H36.3338C29.8131 53.7196 26.5519 53.7196 24.5271 51.693C22.5005 49.6682 22.5005 46.407 22.5005 39.8863V36.4279Z",
      stroke: "#FDA29B",
      "stroke-width": "2.59375"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M31.147 22.5946V20.0009M48.4386 22.5946V20.0009M23.3657 31.2404H56.2199",
      stroke: "#FDA29B",
      "stroke-width": "2.59375",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M50.1665 45.0725C50.1665 45.5311 49.9843 45.9709 49.66 46.2952C49.3358 46.6195 48.8959 46.8016 48.4373 46.8016C47.9787 46.8016 47.5389 46.6195 47.2146 46.2952C46.8903 45.9709 46.7082 45.5311 46.7082 45.0725C46.7082 44.6139 46.8903 44.174 47.2146 43.8498C47.5389 43.5255 47.9787 43.3433 48.4373 43.3433C48.8959 43.3433 49.3358 43.5255 49.66 43.8498C49.9843 44.174 50.1665 44.6139 50.1665 45.0725ZM50.1665 38.1558C50.1665 38.6144 49.9843 39.0542 49.66 39.3785C49.3358 39.7028 48.8959 39.885 48.4373 39.885C47.9787 39.885 47.5389 39.7028 47.2146 39.3785C46.8903 39.0542 46.7082 38.6144 46.7082 38.1558C46.7082 37.6972 46.8903 37.2574 47.2146 36.9331C47.5389 36.6088 47.9787 36.4266 48.4373 36.4266C48.8959 36.4266 49.3358 36.6088 49.66 36.9331C49.9843 37.2574 50.1665 37.6972 50.1665 38.1558ZM41.5207 45.0725C41.5207 45.5311 41.3385 45.9709 41.0142 46.2952C40.6899 46.6195 40.2501 46.8016 39.7915 46.8016C39.3329 46.8016 38.8931 46.6195 38.5688 46.2952C38.2445 45.9709 38.0623 45.5311 38.0623 45.0725C38.0623 44.6139 38.2445 44.174 38.5688 43.8498C38.8931 43.5255 39.3329 43.3433 39.7915 43.3433C40.2501 43.3433 40.6899 43.5255 41.0142 43.8498C41.3385 44.174 41.5207 44.6139 41.5207 45.0725ZM41.5207 38.1558C41.5207 38.6144 41.3385 39.0542 41.0142 39.3785C40.6899 39.7028 40.2501 39.885 39.7915 39.885C39.3329 39.885 38.8931 39.7028 38.5688 39.3785C38.2445 39.0542 38.0623 38.6144 38.0623 38.1558C38.0623 37.6972 38.2445 37.2574 38.5688 36.9331C38.8931 36.6088 39.3329 36.4266 39.7915 36.4266C40.2501 36.4266 40.6899 36.6088 41.0142 36.9331C41.3385 37.2574 41.5207 37.6972 41.5207 38.1558ZM32.8748 45.0725C32.8748 45.5311 32.6927 45.9709 32.3684 46.2952C32.0441 46.6195 31.6043 46.8016 31.1457 46.8016C30.6871 46.8016 30.2472 46.6195 29.923 46.2952C29.5987 45.9709 29.4165 45.5311 29.4165 45.0725C29.4165 44.6139 29.5987 44.174 29.923 43.8498C30.2472 43.5255 30.6871 43.3433 31.1457 43.3433C31.6043 43.3433 32.0441 43.5255 32.3684 43.8498C32.6927 44.174 32.8748 44.6139 32.8748 45.0725ZM32.8748 38.1558C32.8748 38.6144 32.6927 39.0542 32.3684 39.3785C32.0441 39.7028 31.6043 39.885 31.1457 39.885C30.6871 39.885 30.2472 39.7028 29.923 39.3785C29.5987 39.0542 29.4165 38.6144 29.4165 38.1558C29.4165 37.6972 29.5987 37.2574 29.923 36.9331C30.2472 36.6088 30.6871 36.4266 31.1457 36.4266C31.6043 36.4266 32.0441 36.6088 32.3684 36.9331C32.6927 37.2574 32.8748 37.6972 32.8748 38.1558Z",
      fill: "#FDA29B"
    })
  ])
], -1))
const _hoisted_62 = { class: "mt-6 text-center" }
const _hoisted_63 = { class: "mt-6 text-center" }
const _hoisted_64 = { class: "text-sm text-[#475467]" }
const _hoisted_65 = { class: "mt-6 flex justify-around items-center gap-3" }
const _hoisted_66 = { class: "text-center mt-2" }
const _hoisted_67 = { class: "text-sm text-[#475467]" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_69 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_70 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "calendar-icon",
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#FDA29B",
      "fill-opacity": "0.25"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M22.5005 36.4279C22.5005 29.9073 22.5005 26.646 24.5271 24.6212C26.5519 22.5946 29.8131 22.5946 36.3338 22.5946H43.2505C49.7712 22.5946 53.0324 22.5946 55.0572 24.6212C57.0838 26.646 57.0838 29.9073 57.0838 36.4279V39.8863C57.0838 46.407 57.0838 49.6682 55.0572 51.693C53.0324 53.7196 49.7712 53.7196 43.2505 53.7196H36.3338C29.8131 53.7196 26.5519 53.7196 24.5271 51.693C22.5005 49.6682 22.5005 46.407 22.5005 39.8863V36.4279Z",
      stroke: "#FDA29B",
      "stroke-width": "2.59375"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M31.147 22.5946V20.0009M48.4386 22.5946V20.0009M23.3657 31.2404H56.2199",
      stroke: "#FDA29B",
      "stroke-width": "2.59375",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M50.1665 45.0725C50.1665 45.5311 49.9843 45.9709 49.66 46.2952C49.3358 46.6195 48.8959 46.8016 48.4373 46.8016C47.9787 46.8016 47.5389 46.6195 47.2146 46.2952C46.8903 45.9709 46.7082 45.5311 46.7082 45.0725C46.7082 44.6139 46.8903 44.174 47.2146 43.8498C47.5389 43.5255 47.9787 43.3433 48.4373 43.3433C48.8959 43.3433 49.3358 43.5255 49.66 43.8498C49.9843 44.174 50.1665 44.6139 50.1665 45.0725ZM50.1665 38.1558C50.1665 38.6144 49.9843 39.0542 49.66 39.3785C49.3358 39.7028 48.8959 39.885 48.4373 39.885C47.9787 39.885 47.5389 39.7028 47.2146 39.3785C46.8903 39.0542 46.7082 38.6144 46.7082 38.1558C46.7082 37.6972 46.8903 37.2574 47.2146 36.9331C47.5389 36.6088 47.9787 36.4266 48.4373 36.4266C48.8959 36.4266 49.3358 36.6088 49.66 36.9331C49.9843 37.2574 50.1665 37.6972 50.1665 38.1558ZM41.5207 45.0725C41.5207 45.5311 41.3385 45.9709 41.0142 46.2952C40.6899 46.6195 40.2501 46.8016 39.7915 46.8016C39.3329 46.8016 38.8931 46.6195 38.5688 46.2952C38.2445 45.9709 38.0623 45.5311 38.0623 45.0725C38.0623 44.6139 38.2445 44.174 38.5688 43.8498C38.8931 43.5255 39.3329 43.3433 39.7915 43.3433C40.2501 43.3433 40.6899 43.5255 41.0142 43.8498C41.3385 44.174 41.5207 44.6139 41.5207 45.0725ZM41.5207 38.1558C41.5207 38.6144 41.3385 39.0542 41.0142 39.3785C40.6899 39.7028 40.2501 39.885 39.7915 39.885C39.3329 39.885 38.8931 39.7028 38.5688 39.3785C38.2445 39.0542 38.0623 38.6144 38.0623 38.1558C38.0623 37.6972 38.2445 37.2574 38.5688 36.9331C38.8931 36.6088 39.3329 36.4266 39.7915 36.4266C40.2501 36.4266 40.6899 36.6088 41.0142 36.9331C41.3385 37.2574 41.5207 37.6972 41.5207 38.1558ZM32.8748 45.0725C32.8748 45.5311 32.6927 45.9709 32.3684 46.2952C32.0441 46.6195 31.6043 46.8016 31.1457 46.8016C30.6871 46.8016 30.2472 46.6195 29.923 46.2952C29.5987 45.9709 29.4165 45.5311 29.4165 45.0725C29.4165 44.6139 29.5987 44.174 29.923 43.8498C30.2472 43.5255 30.6871 43.3433 31.1457 43.3433C31.6043 43.3433 32.0441 43.5255 32.3684 43.8498C32.6927 44.174 32.8748 44.6139 32.8748 45.0725ZM32.8748 38.1558C32.8748 38.6144 32.6927 39.0542 32.3684 39.3785C32.0441 39.7028 31.6043 39.885 31.1457 39.885C30.6871 39.885 30.2472 39.7028 29.923 39.3785C29.5987 39.0542 29.4165 38.6144 29.4165 38.1558C29.4165 37.6972 29.5987 37.2574 29.923 36.9331C30.2472 36.6088 30.6871 36.4266 31.1457 36.4266C31.6043 36.4266 32.0441 36.6088 32.3684 36.9331C32.6927 37.2574 32.8748 37.6972 32.8748 38.1558Z",
      fill: "#FDA29B"
    })
  ])
], -1))
const _hoisted_72 = { class: "mt-6 text-center" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "mt-6 text-center" }
const _hoisted_76 = { class: "text-sm text-[#475467]" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = { class: "text-center" }
const _hoisted_79 = { class: "mt-6 flex justify-around items-center gap-3" }
const _hoisted_80 = { class: "text-center mt-2" }
const _hoisted_81 = { class: "text-sm text-[#475467]" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_83 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_84 = { class: "flex min-h-full items-end justify-center p-8 text-center sm:items-center" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "13",
  height: "13",
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.587 9.72511C10.7015 9.83959 10.7658 9.99486 10.7658 10.1568C10.7658 10.3187 10.7015 10.4739 10.587 10.5884C10.4725 10.7029 10.3173 10.7672 10.1554 10.7672C9.99346 10.7672 9.83819 10.7029 9.72371 10.5884L6.49961 7.36328L3.27449 10.5874C3.16002 10.7019 3.00475 10.7662 2.84285 10.7662C2.68096 10.7662 2.52569 10.7019 2.41121 10.5874C2.29674 10.4729 2.23242 10.3176 2.23242 10.1557C2.23242 9.99384 2.29674 9.83858 2.41121 9.7241L5.63633 6.5L2.41223 3.27488C2.29775 3.1604 2.23344 3.00514 2.23344 2.84324C2.23344 2.68134 2.29775 2.52608 2.41223 2.4116C2.52671 2.29712 2.68197 2.23281 2.84387 2.23281C3.00577 2.23281 3.16103 2.29712 3.27551 2.4116L6.49961 5.63672L9.72473 2.41109C9.83921 2.29661 9.99447 2.2323 10.1564 2.2323C10.3183 2.2323 10.4735 2.29661 10.588 2.41109C10.7025 2.52557 10.7668 2.68084 10.7668 2.84273C10.7668 3.00463 10.7025 3.15989 10.588 3.27437L7.36289 6.5L10.587 9.72511Z",
    fill: "#828284"
  })
], -1))
const _hoisted_86 = [
  _hoisted_85
]
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mx-auto flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "78",
    height: "77",
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      x: "0.9375",
      width: "76.125",
      height: "76.125",
      rx: "38.0625",
      fill: "#53DDC9",
      "fill-opacity": "0.25"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M59.9167 25H33.375C31.1292 25 29.2917 26.8375 29.2917 29.0833V47.4583C29.2917 48.5413 29.7219 49.5799 30.4876 50.3457C31.2534 51.1115 32.292 51.5417 33.375 51.5417H59.9167C62.1829 51.5417 64 49.7246 64 47.4583V29.0833C64 28.0004 63.5698 26.9618 62.804 26.196C62.0382 25.4302 60.9996 25 59.9167 25ZM59.9167 47.4583H33.375V32.4929L46.6458 39.2917L59.9167 32.4929V47.4583ZM46.6458 35.8413L33.375 29.0833H59.9167L46.6458 35.8413ZM25.2083 47.4583C25.2083 47.8054 25.2696 48.1321 25.3104 48.4792H17.0417C15.9147 48.4792 15 47.5604 15 46.4375C15 45.3146 15.9147 44.3958 17.0417 44.3958H25.2083V47.4583ZM21.125 28.0625H25.3104C25.2696 28.4096 25.2083 28.7362 25.2083 29.0833V32.1458H21.125C20.0021 32.1458 19.0833 31.2271 19.0833 30.1042C19.0833 28.9812 20.0021 28.0625 21.125 28.0625ZM17.0417 38.2708C17.0417 37.1479 17.9604 36.2292 19.0833 36.2292H25.2083V40.3125H19.0833C17.9604 40.3125 17.0417 39.3937 17.0417 38.2708Z",
      fill: "#53DDC9"
    })
  ])
], -1))
const _hoisted_88 = { class: "mt-6 text-center" }
const _hoisted_89 = { class: "text-center" }
const _hoisted_90 = { class: "text-sm text-[#475467]" }
const _hoisted_91 = { class: "p-4" }
const _hoisted_92 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_93 = { class: "bg-[#FDA29B] rounded-full p-3 text-white" }
const _hoisted_94 = { class: "mt-5 text-center" }
const _hoisted_95 = { class: "text-center" }
const _hoisted_96 = { class: "text-sm text-[#475467] mb-8" }
const _hoisted_97 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_98 = {
  key: 0,
  class: "relative ml-2"
}

import TeacherDetails from "@/modules/main/components/TeacherDetailsComponent.vue";
import GradesClassesDetailsComponent from "@/modules/main/components/GradesClassesDetailsComponent.vue";
import { countryOptions } from "@/helper/countries";
import { CheckIcon, ChevronUpDownIcon, ExclamationCircleIcon } from "@heroicons/vue/20/solid";
import { TrashIcon, XMarkIcon } from "@heroicons/vue/24/outline";
import { FormKitNode } from "@formkit/core";
import { useAdminStore } from "@/stores/adminStore";
import { CheckCircleIcon } from "@heroicons/vue/20/solid";
import { ref, watch, computed, onMounted } from "vue";
import i18n from "@/plugins/i18n";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import { useSchoolStore } from "@/stores/schoolStore";
import { useSchoolGroupStore } from "@/stores/schoolGroupsStore";
import { School } from "@/interfaces/school.interface";
import { Admin } from "@/interfaces/admin.interface";
import { useRouter } from "vue-router";
import { useRolloverStore } from "@/stores/rolloverStore";
import { Rollover } from "@/interfaces/rollover.interface";
import { useLearnerStore } from "@/stores/learnerStore";
import RolloverAlertComponent from "@/modules/main/components/RolloverAlertComponent.vue";
import { useFilterStore } from "@/stores/filterStore";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/vue";
import SchoolLicenseAlert from "../SchoolLicenseAlertComponent.vue";
import LicenseManagement from "./LicenseManagementComponent.vue";

interface SearchOption {
  id: string;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditSchoolComponent',
  props: {
  context: {
    type: Object,
    default: () => ({}),
  },
},
  emits: ["updateValue"],
  setup(__props, { emit: emits }) {

const props = __props;

const learnerStore = useLearnerStore();
const adminStore = useAdminStore();
const schoolStore = useSchoolStore();
const schoolGroupStore = useSchoolGroupStore();
const router = useRouter();
const rolloverStore = useRolloverStore();
const filterStore = useFilterStore();



const showRollover = ref(false);
const completeRolloverModal = ref(false);
const showModal = ref(false);
const newRolloverDate = ref("");
const rolloverDate = ref("2024-01-01");
const isCalendarHidden = ref(false);
const confirmRolloverDateModal = ref(false);
const updateSuccess = ref(false);
const responseMessage = ref("");
const deleteChampSuccess = ref(false);
const showChampionDeleteNotification = ref(false);
const confirmChampionDeletionModal = ref(false);

const schoolObject = ref({
  _id: "",
  name: "",
  code: "",
  description: "",
  language: "",
  domain: "",
  status: "",
  emisNumber: "",
  isPartOfGroup: false,
  schoolGroup: "",
  academicYearStart: "",
  academicYearEnd: "",
  preferredLang: "",
  location: {
    city: "",
    country: "",
    street: "",
  }
});

// Store initial values for comparison
const initialSchoolObject = ref({
  _id: "",
  name: "",
  code: "",
  description: "",
  language: "",
  domain: "",
  status: "",
  emisNumber: "",
  isPartOfGroup: false,
  schoolGroup: "",
  academicYearStart: "",
  academicYearEnd: "",
  preferredLang: "",
  location: {
    city: "",
    country: "",
    street: "",
  }
});



const schoolChampions = ref<Admin[]>([]);
const initialSchoolChampions = ref<Admin[]>([]);
const newAdmins = ref<any[]>([]);
const newAdmin = ref({
  firstName: "",
  lastName: "",
  email: "",
  designation: "School Champion",
  status: "inactive",
  roles: [],
  phoneNumber: null,
  school: filterStore.selectedFilters.school,
}) as any;
const updatedFields = ref<{ school?: any; champion?: any }>({});
const searchQuery = ref("");
const selectedOption = ref<SearchOption | null>(null);
const placeholder = ref(i18n.global.t("internal_tools.select").toString());
const buttonIsDisabled = ref(false);

const previewStep = () => {
    emits("updateValue", false);
};

// Computed filtered options based on `searchQuery`
const filteredOptions = computed(() =>
  searchQuery.value === ""
    ? countryOptions
    : countryOptions.filter((o) =>
        o.name.toLowerCase().includes(searchQuery.value.toLowerCase())
      )
);

const handleScrollToElement = (selector: string) => {
  const element = document.querySelector(selector);

  if (element) {
    // Scroll the element into view
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else {
    console.warn(`Element with selector "${selector}" not found.`);
  }
}

const addChampion = () => {
  // Spread newAdmin to create a new instance and generate a unique _id
  newAdmins.value.push({
    ...newAdmin.value,
    _id: Math.random().toString(36).substring(2) + Date.now().toString(36),
  });
};

const adminToDelete = ref<Admin | null>(null);

const showConfirmChampionDeletionModal = (admin: Admin, e: Event) => {
  // stop page refresh
  e.preventDefault();
  
  confirmChampionDeletionModal.value = true;
  adminToDelete.value = admin;
};

const removeChampion = (index: number) => {
  newAdmins.value.splice(index, 1);
};

const removeExistingChampion = async (admin: Admin, e: Event) => {
  // stop page refresh
  e.preventDefault();
  deleteChampSuccess.value = false;

  // get the selected champion's id
  const championId = admin._id;

  //  use new action to delete the champion
  if (championId) {

    const deletedChampion = await adminStore.deleteExistingChampion(championId, filterStore.selectedFilters.school);
    deleteChampSuccess.value = deletedChampion;
    showChampionDeleteNotification.value = deletedChampion;
  } else {
    console.error("Champion ID is undefined");
    deleteChampSuccess.value = false;
  }

  confirmChampionDeletionModal.value = false;
};

const closeSuccess = () => {
  updateSuccess.value = false;
  responseMessage.value = "";
};

// Computed property for FormKit select options
const localeOptions = computed(() =>
  schoolStore.getLocales.map((locale) => ({
    label: locale.name, // Display name
    value: locale.code, // Code as value
  }))
);

// Function to check for changes when saving
const handleNext = async () => {
  const schoolChanges = findChangedFields(
    initialSchoolObject.value,
    schoolObject.value
  );

  updatedFields.value = {
    ...(Object.keys(schoolChanges).length ? { school: schoolChanges } : {})
  };

  // check for new admins
  if (newAdmins.value.length > 0) {
    let successCount = 0;

    for (const admin of newAdmins.value) {
      //Check if all necessary fields are filled
      if (admin.firstName && admin.lastName && admin.email) {

        // Add the 'school' key to the admin object
        admin.school = schoolStore.currentSchool?._id;
        
        let res = await adminStore.createNewAdmin(admin);

        if (res?._id) {
          //push new admin to schoolChampions array
          schoolStore.updateSchoolChampion(res);
          successCount++;
        }

      } else {
        console.log("Admin data is incomplete");
      }
    }

    // Only update the response message if all admins were successfully added
    if (successCount === newAdmins.value.length) {

      // Fetch updated school structure
      await schoolStore.fetchSchoolStructure(filterStore.selectedFilters.school);
      
      // clear admin 
      newAdmins.value = [];

      // Update the school champions
      updateChampionsDetails();

      console.log("All new admins were successfully added");
      responseMessage.value = i18n.global
        .t("internal_tools.success.champions_message")
        .toString();
      updateSuccess.value = true;

    } else {
      updateSuccess.value = false;
    }
  }

  // udpate school details
  if (updatedFields.value.school) {
    if (schoolStore.getCurrentSchool) {

      const result = await schoolStore.updateSchool(
        filterStore.selectedFilters.school,
        updatedFields.value.school
      );
      
      if (result) {
        // Fetch updated school structure
        updateSchoolDetails();
        responseMessage.value = i18n.global
          .t("internal_tools.success.school_message")
          .toString();
        updateSuccess.value = true;
    
      }
    }
  } 

  // clear the updatedFields
  // updatedFields.value = {};

  //Enable button again
  buttonIsDisabled.value = false;
};

// Fetch initial data
const clearData = async () => {
  const selectedSchool = filterStore.selectedSchool._id;

  if (selectedSchool) {

    // Hide rollover notification
    showRollover.value = false;

    // Clear previous changes and inputs
    schoolObject.value = { ...initialSchoolObject.value };
    schoolChampions.value = { ...initialSchoolChampions.value };

    // Clear any previously stored changes
    updatedFields.value = {};

    // Clear the newAdmins array
    newAdmins.value = [];

    //clear success message
    updateSuccess.value = false;

    //trying to clear the country value
    selectedOption.value = { id: "", name: "" };
  }
};

const updateSchoolDetails = async () => {
  const currentSchool = schoolStore.getCurrentSchool;
    if (currentSchool) {
      schoolObject.value = { ...schoolStore.currentSchool };
      initialSchoolObject.value = JSON.parse(
        JSON.stringify(schoolStore.currentSchool)
      );

      await rolloverStore.fetchSchoolRollover(currentSchool._id);
      
      if (rolloverStore.rollover?.rolloverDate) {
          const date = new Date(rolloverStore.rollover?.rolloverDate);

          // date in format YYYY-MM-DD
          rolloverDate.value = date.toISOString().split('T')[0];
        }

        if (
          rolloverStore.rollover &&
          rolloverStore.rollover?.school === schoolStore.currentSchool?._id &&
          rolloverStore.rollover?.isComplete !== true
          ) {
            showRollover.value = true;
        }
      }
};

const updateChampionsDetails = async () => {
  // Assign all school admins to `schoolChampions`
  if (schoolStore.currentSchoolStructure?.schoolChampions) {
    schoolChampions.value =
      schoolStore.currentSchoolStructure.schoolChampions.map((admin) => ({
        ...admin,
      }));
    initialSchoolChampions.value = JSON.parse(
      JSON.stringify(schoolStore.currentSchoolStructure.schoolChampions)
    );
  }
}

const findChangedFieldsAdmin = (initialData: Admin[], currentData: Admin[]) => {
  return currentData
    .map((currentAdmin, index) => {
      const initialAdmin = initialData[index];
      const changes: { [key: string]: any } = {};

      for (const key in currentAdmin) {
        let currentValue = currentAdmin[key as keyof Admin];
        let initialValue = initialAdmin[key as keyof Admin];

        if (typeof currentValue === "string")
          currentValue = currentValue.trim();
        if (typeof initialValue === "string")
          initialValue = initialValue.trim();

        if (
          (currentValue === null ||
            currentValue === "" ||
            (Array.isArray(currentValue) && currentValue.length === 0)) &&
          (initialValue === null ||
            initialValue === "" ||
            (Array.isArray(initialValue) && initialValue.length === 0))
        ) {
          continue;
        } else if (
          typeof currentValue === "object" &&
          currentValue !== null &&
          !Array.isArray(currentValue)
        ) {
          const nestedChanges = findChangedFieldsAdmin(
            [initialValue] as unknown as Admin[],
            [currentValue] as unknown as Admin[]
          );
          if (Object.keys(nestedChanges).length > 0) {
            changes[key] = nestedChanges;
          }
        } else if (
          JSON.stringify(currentValue) !== JSON.stringify(initialValue)
        ) {
          changes[key] = currentValue;
        }
      }

      // Include `_id` if there are any changes for this admin
      if (Object.keys(changes).length > 0) {
        changes["_id"] = currentAdmin._id;
      }

      return Object.keys(changes).length > 0 ? changes : null;
    })
    .filter((change) => change !== null);
};

const findChangedFields = (initialData: School, currentData: School) => {
  const changes: { [key: string]: any } = {};

  for (const key in currentData) {
    let currentValue = currentData[key as keyof School];
    let initialValue = initialData[key as keyof School];

    // Trim strings before comparing
    if (typeof currentValue === "string") currentValue = currentValue.trim();
    if (typeof initialValue === "string") initialValue = initialValue.trim();

    if (
      (currentValue === null ||
        currentValue === "" ||
        (Array.isArray(currentValue) && currentValue.length === 0)) &&
      (initialValue === null ||
        initialValue === "" ||
        (Array.isArray(initialValue) && initialValue.length === 0))
    ) {
      // Skip if both initial and current values are null, empty string, or empty array
      continue;
    } else if (
      typeof currentValue === "object" &&
      currentValue !== null &&
      !Array.isArray(currentValue)
    ) {
      // Recursively check nested objects
      const nestedChanges = findChangedFields(
        initialValue as unknown as School,
        currentValue as unknown as School
      );
      if (Object.keys(nestedChanges).length > 0) {
        (changes as { [key: string]: any })[key] = nestedChanges;
      }
    } else if (JSON.stringify(currentValue) !== JSON.stringify(initialValue)) {
      // Add only changed or non-empty values to changes
      changes[key] = currentValue;
    }
  }

  return changes;
};

// Change coutry casing
const formatCountryName = (country: string) => {
  //check if the country is in the countryOptions
  const countryExist = countryOptions.find((o) => o.id === country);

  //if the country is not in the countryOptions, return the selectedOption value
  if (!countryExist) {
    return selectedOption.value?.name;
  }

  return country
    ? country
        .split("-")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ")
    : "";
};

onMounted(async () => {
  const initialCountryId = schoolStore.getCurrentSchool?.location.country;

  // Call functions onMounted to trigger the same logic as the watchers
  clearData();
  updateSchoolDetails();
  updateChampionsDetails();

  selectedOption.value =
    countryOptions.find((o) => o.id === initialCountryId) || null;
  searchQuery.value = selectedOption.value ? selectedOption.value.name : "";
});

const canceldeletion = () => {
  confirmChampionDeletionModal.value = false;
};

const confirmDates = async () => {
  confirmRolloverDateModal.value = false;

  if (newRolloverDate.value) {
    rolloverDate.value = newRolloverDate.value;

    const currentRollOver = rolloverStore.rollover as Rollover;

    currentRollOver.status.learnerRollover = "in_review";
    currentRollOver.rolloverDate = new Date(
      newRolloverDate.value
    ).toISOString();
    await rolloverStore.updateRolloverObject(currentRollOver);

    router.push("/main/incomplete-rollover");
  } else if (rolloverDate.value) {
    const currentRollOver = rolloverStore.rollover as Rollover;
    currentRollOver.status.learnerRollover = "in_review";

    await rolloverStore.updateRolloverObject(currentRollOver);
    router.push("/main/incomplete-rollover");
  } else {
    router.push("/main/incomplete-rollover");
  }
};

const confirmRolloverComplete = async () => {
  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver) {
    currentRollOver.isComplete = true;
    await rolloverStore.updateRolloverObject(currentRollOver);
  }

  router.push("/main/internal");
};

const email_exists = async (node: FormKitNode): Promise<boolean> => {
  try {
    const emailExists = await schoolStore?.validateEmail(node.value as string);
    buttonIsDisabled.value = emailExists; // Disable button if email exists
    return !emailExists; // Validation passes if email does not exist
  } catch (error) {
    buttonIsDisabled.value = true; // Disable on error
    return true;
  }
};

// Define watchers
watch(() => filterStore.selectedFilters.school, clearData);
watch(() => schoolStore.getSchoolStructure?.schoolChampions, updateChampionsDetails);
watch(() => schoolStore.getCurrentSchool, updateSchoolDetails);

// Watch `selectedOption` to update `searchQuery` and bind to `schoolObject` country ID
watch(selectedOption, (newOption) => {
  searchQuery.value = newOption ? newOption.name : "";
  schoolObject.value.location.country = newOption?.id || "";
});


const existingChampions = ref<Admin[]>([]);
const selectedChampions = ref<{ [key: string]: string }>({});
const existingChampionsBtn = ref(false);

const addExistingChampion = () => {
  existingChampionsBtn.value = true;
  existingChampions.value.push({
    _id: Math.random().toString(36).substring(2) + Date.now().toString(36),
    firstName: '',
    lastName: '',
    email: '',
    designation: 'School Champion',
    status: 'inactive',
    roles: [],
    phoneNumber: null,
  });
};

const removeExistingMultiChampion = (index: number) => {
  existingChampions.value.splice(index, 1);
};

const championOptions = computed(() => {
  const schoolChampionIds = schoolStore.currentSchoolStructure?.schoolChampions.map(champion => champion._id) || [];
  return schoolGroupStore.champions
    .filter(champion => !schoolChampionIds.includes(champion._id))
    .map(champion => ({
      label: `${champion.firstName} ${champion.lastName}`,
      value: champion._id,
    })) || [];
});

const getChampionDetails = (championId) => {
  return schoolGroupStore.champions.find((champion) => champion._id === championId) || {};
};

onMounted(async () => {
  const schoolGroupId = schoolStore.currentSchool?.schoolGroup;
  if (schoolGroupId) {
    await schoolGroupStore.fetchAllSchoolChampions(schoolGroupId);
  }
});

const saveExistingChampions = async () => {
  const adminIds = Object.values(selectedChampions.value);
  const schoolId = schoolStore.currentSchool?._id;
  if (schoolId) {
    try {
      await schoolStore.updateAdminRoles(adminIds, schoolId);
    } catch (error) {
      alert('ERROR: Could not add existing admin.');
      console.warn(error);
    } finally {
      // Fetch updated school structure
      await schoolStore.fetchSchoolStructure(filterStore.selectedFilters.school);
      // Update the school champions
      updateChampionsDetails();
      //reset view
      existingChampionsBtn.value = false;
      existingChampions.value = [];
    }    
  }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (previewStep())),
        type: "submit",
        class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white gap-2"
      }, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('internal_tools.school_group.btn_back')), 1)
      ])
    ]),
    (_unref(rolloverStore).loader.rollover === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (showRollover.value && _unref(rolloverStore).loader.rollover != true)
      ? (_openBlock(), _createBlock(RolloverAlertComponent, {
          key: 1,
          class: "mt-6",
          rollover: (_unref(rolloverStore).rollover as Rollover),
          onCompleteRolloverModal: _cache[1] || (_cache[1] = ($event: any) => (completeRolloverModal.value = $event)),
          onConfirmRolloverDateModal: _cache[2] || (_cache[2] = ($event: any) => (confirmRolloverDateModal.value = $event))
        }, null, 8, ["rollover"]))
      : _createCommentVNode("", true),
    _createVNode(SchoolLicenseAlert, {
      onScrollToElement: handleScrollToElement,
      license: _unref(schoolStore).currentSchool?.schoolLicense
    }, null, 8, ["license"]),
    (
        _unref(schoolStore).loading === true || _unref(learnerStore).loader.learner === true
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_unref(TabView), { class: "mt-9 pb-4" }, {
            default: _withCtx(() => [
              _createVNode(_unref(TabPanel), {
                header: _ctx.$t('internal_tools.panel.school_details')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormKit, {
                    type: "form",
                    id: "login-form",
                    actions: false
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_FormKit, {
                          type: "text",
                          label: _ctx.$t('internal_tools.form.school_location'),
                          "outer-class": "primary-select primary-select-clear",
                          "inner-class": "bg-white",
                          placeholder: _ctx.$t('internal_tools.form.school_location'),
                          modelValue: schoolObject.value.location.street,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schoolObject.value.location.street) = $event))
                        }, null, 8, ["label", "placeholder", "modelValue"]),
                        _createVNode(_component_FormKit, {
                          type: "text",
                          label: _ctx.$t('internal_tools.form.domain_name'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.domain_name'),
                          modelValue: schoolObject.value.domain,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((schoolObject.value.domain) = $event))
                        }, null, 8, ["label", "placeholder", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_FormKit, {
                          class: "w-1/2",
                          type: "text",
                          label: _ctx.$t('internal_tools.form.city'),
                          "outer-class": "primary-select w-1/2",
                          placeholder: _ctx.$t('internal_tools.form.city_name'),
                          modelValue: schoolObject.value.location.city,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((schoolObject.value.location.city) = $event))
                        }, null, 8, ["label", "placeholder", "modelValue"]),
                        _createVNode(_unref(Combobox), {
                          class: "w-1/2",
                          as: "div",
                          modelValue: selectedOption.value,
                          "onUpdate:modelValue": [
                            _cache[8] || (_cache[8] = ($event: any) => ((selectedOption).value = $event)),
                            _cache[9] || (_cache[9] = ($event: any) => (searchQuery.value = ''))
                          ],
                          label: _ctx.$t('internal_tools.form.city')
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("internal_tools.form.country_title")), 1),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_unref(ComboboxInput), {
                                class: "w-full rounded-md border-0 bg-white py-[18px] pl-3 pr-10 text-[#6a737f] shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-[#155EEF] font-normal text-base",
                                placeholder: placeholder.value,
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (searchQuery.value = $event.target.value)),
                                onBlur: _cache[7] || (_cache[7] = ($event: any) => (searchQuery.value = '')),
                                "display-value": 
                      () =>
                        formatCountryName(schoolObject.value.location.country) || ''
                    
                              }, null, 8, ["placeholder", "display-value"]),
                              _createVNode(_unref(ComboboxButton), { class: "absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(ChevronUpDownIcon), {
                                    class: "h-5 w-5 text-gray-400",
                                    "aria-hidden": "true"
                                  })
                                ]),
                                _: 1
                              }),
                              (filteredOptions.value.length > 0)
                                ? (_openBlock(), _createBlock(_unref(ComboboxOptions), {
                                    key: 0,
                                    class: "dropdown-options absolute z-20 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                                        return (_openBlock(), _createBlock(_unref(ComboboxOption), {
                                          key: option.id,
                                          value: option,
                                          as: "template"
                                        }, {
                                          default: _withCtx(({ active, selected }) => [
                                            _createElementVNode("li", {
                                              class: _normalizeClass([
                          'relative cursor-default select-none py-2 pl-8 pr-4',
                          active ? 'bg-[#155EEF] text-white' : 'text-gray-900',
                        ])
                                            }, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass([
                            'block truncate',
                            selected && 'font-semibold',
                          ])
                                              }, _toDisplayString(option.name), 3),
                                              selected
                                                ? (_openBlock(), _createElementBlock("span", {
                                                    key: 0,
                                                    class: _normalizeClass([
                            'absolute inset-y-0 left-0 flex items-center pl-1.5',
                            active ? 'text-white' : 'text-[#155EEF]',
                          ])
                                                  }, [
                                                    _createVNode(_unref(CheckIcon), {
                                                      class: "h-5 w-5",
                                                      "aria-hidden": "true"
                                                    })
                                                  ], 2))
                                                : _createCommentVNode("", true)
                                            ], 2)
                                          ]),
                                          _: 2
                                        }, 1032, ["value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "label"])
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_FormKit, {
                          type: "select",
                          name: "locale",
                          options: localeOptions.value,
                          label: _ctx.$t('internal_tools.form.language_title'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.language'),
                          style: { color: '#667085', height: '3.5rem' },
                          modelValue: schoolObject.value.preferredLang,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((schoolObject.value.preferredLang) = $event))
                        }, null, 8, ["options", "label", "placeholder", "modelValue"]),
                        _createVNode(_component_FormKit, {
                          type: "text",
                          label: _ctx.$t('internal_tools.form.emis_number'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.emis_number'),
                          modelValue: schoolObject.value.emisNumber,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((schoolObject.value.emisNumber) = $event))
                        }, null, 8, ["label", "placeholder", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_FormKit, {
                          type: "text",
                          label: _ctx.$t('internal_tools.form.start_month'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.month'),
                          modelValue: schoolObject.value.academicYearStart,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((schoolObject.value.academicYearStart) = $event))
                        }, null, 8, ["label", "placeholder", "modelValue"]),
                        _createVNode(_component_FormKit, {
                          type: "text",
                          label: _ctx.$t('internal_tools.form.end_month'),
                          "outer-class": "primary-select",
                          placeholder: _ctx.$t('internal_tools.form.month'),
                          modelValue: schoolObject.value.academicYearEnd,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((schoolObject.value.academicYearEnd) = $event))
                        }, null, 8, ["label", "placeholder", "modelValue"])
                      ]),
                      _createElementVNode("h1", _hoisted_17, _toDisplayString(_ctx.$t("internal_tools.form.add_champion")), 1),
                      _hoisted_18,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolChampions.value, (admin) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: admin._id,
                          class: "columns-4 mt-4 relative"
                        }, [
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: _ctx.$t('internal_tools.form.champion_name'),
                            readonly: "",
                            style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.champion_name'),
                            modelValue: admin.firstName,
                            "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event)
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "email",
                            label: _ctx.$t('internal_tools.form.champion_email'),
                            readonly: "",
                            style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.champion_email'),
                            modelValue: admin.email,
                            "onUpdate:modelValue": ($event: any) => ((admin.email) = $event)
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "text",
                            label: _ctx.$t('internal_tools.form.champion_title'),
                            readonly: "",
                            style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.champion_title'),
                            modelValue: admin.designation,
                            "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_FormKit, {
                            type: "number",
                            label: _ctx.$t('internal_tools.form.champion_phone'),
                            readonly: "",
                            style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                            modelValue: admin.phoneNumber,
                            "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                          _createElementVNode("div", _hoisted_19, [
                            (_unref(adminStore).loader.deleteAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                  _createVNode(_component_spinner_loader)
                                ]))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: ($event: any) => (showConfirmChampionDeletionModal(admin, $event)),
                                  class: "mt-2 text-red-500"
                                }, [
                                  _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                                ], 8, _hoisted_21))
                          ])
                        ]))
                      }), 128)),
                      (showChampionDeleteNotification.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass({
              'rounded-md p-4 mt-5': true,
              'bg-green-50': deleteChampSuccess.value,
              'bg-red-50': !deleteChampSuccess.value,
              })
                          }, [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                (_openBlock(), _createBlock(_resolveDynamicComponent(deleteChampSuccess.value ? _unref(CheckCircleIcon) : _unref(ExclamationCircleIcon)), {
                                  class: _normalizeClass({
                  'h-5 w-5': true,
                  'text-green-400': deleteChampSuccess.value,
                  'text-red-400': !deleteChampSuccess.value,
                }),
                                  "aria-hidden": "true"
                                }, null, 8, ["class"]))
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("p", {
                                  class: _normalizeClass({
                  'text-sm font-medium': true,
                  'text-green-800': deleteChampSuccess.value,
                  'text-red-800': !deleteChampSuccess.value,
                })
                                }, _toDisplayString(deleteChampSuccess.value
                  ? _ctx.$t("internal_view.delete_champion_success")
                  : _ctx.$t("internal_view.delete_champion_error")), 3)
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass({
                  'inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2': true,
                  'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-green-600 focus:ring-offset-green-50':
                    deleteChampSuccess.value,
                  'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-red-600 focus:ring-offset-red-50':
                    !deleteChampSuccess.value,
                  }),
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (showChampionDeleteNotification.value = false))
                                  }, [
                                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.$t(
                    deleteChampSuccess.value
                    ? "internal_tools.success.btnClose"
                    : "internal_tools.error.btnClose"
                  )), 1),
                                    _createVNode(_unref(XMarkIcon), {
                                      class: "h-5 w-5",
                                      "aria-hidden": "true"
                                    })
                                  ], 2)
                                ])
                              ])
                            ])
                          ], 2))
                        : _createCommentVNode("", true),
                      (_unref(schoolStore).schoolStructureLoader === true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(newAdmins.value, (admin, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: admin._id,
                              class: "columns-5 mt-4 mb-2 relative"
                            }, [
                              _createVNode(_component_FormKit, {
                                type: "text",
                                label: _ctx.$t('internal_tools.form.champion_name'),
                                "outer-class": "primary-select",
                                placeholder: _ctx.$t('internal_tools.form.champion_name'),
                                modelValue: admin.firstName,
                                "onUpdate:modelValue": ($event: any) => ((admin.firstName) = $event),
                                style: { position: 'relative' },
                                validation: "required",
                                "messages-class": 'absolute'
                              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_FormKit, {
                                type: "text",
                                label: _ctx.$t('internal_tools.form.champion_surname'),
                                "outer-class": "primary-select",
                                placeholder: _ctx.$t('internal_tools.form.champion_surname'),
                                modelValue: admin.lastName,
                                "onUpdate:modelValue": ($event: any) => ((admin.lastName) = $event),
                                style: { position: 'relative' },
                                validation: "required",
                                "messages-class": 'absolute'
                              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_FormKit, {
                                type: "email",
                                label: _ctx.$t('internal_tools.form.champion_email'),
                                "outer-class": "primary-select",
                                placeholder: _ctx.$t('internal_tools.form.champion_email'),
                                modelValue: admin.email,
                                "onUpdate:modelValue": ($event: any) => ((admin.email) = $event),
                                validation: "required|email|(500)email_exists",
                                style: { position: 'relative' },
                                "validation-rules": { email_exists: email_exists },
                                "validation-messages": {
                  email_exists: _ctx.$t(
                    'add_grades_class_component.step_1.email_exists'
                  ),
                },
                                "messages-class": 'absolute'
                              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"]),
                              _createVNode(_component_FormKit, {
                                type: "text",
                                label: _ctx.$t('internal_tools.form.champion_title'),
                                "outer-class": "primary-select",
                                placeholder: _ctx.$t('internal_tools.form.champion_title'),
                                readonly: "",
                                style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
                                modelValue: admin.designation,
                                "onUpdate:modelValue": ($event: any) => ((admin.designation) = $event)
                              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                              _createVNode(_component_FormKit, {
                                type: "number",
                                label: _ctx.$t('internal_tools.form.champion_phone'),
                                "outer-class": "primary-select",
                                placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                                modelValue: admin.phoneNumber,
                                "onUpdate:modelValue": ($event: any) => ((admin.phoneNumber) = $event)
                              }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (removeChampion(index)),
                                  class: "mt-2 text-red-500"
                                }, [
                                  _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                                ], 8, _hoisted_32)
                              ])
                            ]))
                          }), 128))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("button", {
                      class: "flex gap-[6px] items-center pr-4 py-2 rounded-[1.25rem] justify-center text-[#475467]",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (addChampion()))
                    }, [
                      _hoisted_34,
                      _createElementVNode("h1", _hoisted_35, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "flex gap-[6px] items-center pr-4 py-2 rounded-[1.25rem] justify-center text-[#475467]",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (addExistingChampion()))
                    }, [
                      _hoisted_36,
                      _createElementVNode("h1", _hoisted_37, _toDisplayString(_ctx.$t('internal_tools.form.add_existing_champion')), 1)
                    ]),
                    _createElementVNode("button", {
                      class: _normalizeClass(
                'px-[14px] py-[10px] text-white bg-[#155EEF] border border-[#155EEF] rounded-lg ' +
                (_unref(adminStore).loader.creatingAdmin ||
                _unref(schoolStore).updateLoader ||
                buttonIsDisabled.value
                  ? 'cursor-not-allowed'
                  : 'cursor-pointer')
              ),
                      onClick: _withModifiers(handleNext, ["prevent"]),
                      disabled: 
                _unref(adminStore).loader.creatingAdmin ||
                _unref(schoolStore).updateLoader ||
                buttonIsDisabled.value
              
                    }, [
                      _createElementVNode("h1", _hoisted_39, [
                        (
                    _unref(adminStore).loader.creatingAdmin || _unref(schoolStore).updateLoader
                  )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                              _createVNode(_component_spinner_loader, { color: 'text-white' }),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t("internal_tools.form.btnSaving")), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.$t("internal_tools.form.btnSave")), 1))
                      ])
                    ], 10, _hoisted_38)
                  ]),
                  _createVNode(_component_FormKit, {
                    type: "form",
                    id: "champions-form",
                    actions: false
                  }, {
                    default: _withCtx(() => [
                      (existingChampionsBtn.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_42, " Select an existing admin from another school belonging to this school group. "))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(existingChampions.value, (champion, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: champion._id,
                          class: _normalizeClass(['mt-4 mb-2 relative', selectedChampions.value[champion._id] ? 'columns-4' : 'columns-1'])
                        }, [
                          _createVNode(_component_FormKit, {
                            type: "select",
                            label: _ctx.$t('internal_tools.form.champion_name'),
                            "outer-class": "primary-select",
                            placeholder: _ctx.$t('internal_tools.form.select_champion'),
                            modelValue: selectedChampions.value[champion._id],
                            "onUpdate:modelValue": ($event: any) => ((selectedChampions.value[champion._id]) = $event),
                            options: championOptions.value
                          }, null, 8, ["label", "placeholder", "modelValue", "onUpdate:modelValue", "options"]),
                          (selectedChampions.value[champion._id])
                            ? (_openBlock(), _createBlock(_component_FormKit, {
                                key: 0,
                                type: "text",
                                label: _ctx.$t('internal_tools.form.champion_email'),
                                placeholder: _ctx.$t('internal_tools.form.champion_email'),
                                value: getChampionDetails(selectedChampions.value[champion._id]).email,
                                modelValue: selectedChampions.value[champion._id].email,
                                "onUpdate:modelValue": ($event: any) => ((selectedChampions.value[champion._id].email) = $event),
                                style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' }
                              }, null, 8, ["label", "placeholder", "value", "modelValue", "onUpdate:modelValue"]))
                            : _createCommentVNode("", true),
                          (selectedChampions.value[champion._id])
                            ? (_openBlock(), _createBlock(_component_FormKit, {
                                key: 1,
                                type: "text",
                                label: _ctx.$t('internal_tools.form.champion_title'),
                                placeholder: _ctx.$t('internal_tools.form.champion_title'),
                                value: getChampionDetails(selectedChampions.value[champion._id]).designation,
                                style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
                                readonly: ""
                              }, null, 8, ["label", "placeholder", "value"]))
                            : _createCommentVNode("", true),
                          (selectedChampions.value[champion._id])
                            ? (_openBlock(), _createBlock(_component_FormKit, {
                                key: 2,
                                type: "text",
                                label: _ctx.$t('internal_tools.form.champion_phone'),
                                placeholder: _ctx.$t('internal_tools.form.champion_phone'),
                                value: getChampionDetails(selectedChampions.value[champion._id]).phoneNumber,
                                style: { cursor: 'not-allowed', backgroundColor: '#D2D9E1' },
                                readonly: ""
                              }, null, 8, ["label", "placeholder", "value"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (removeExistingMultiChampion(index)),
                              class: "mt-2 text-red-500"
                            }, [
                              _createVNode(_unref(TrashIcon), { class: "h-5 w-5" })
                            ], 8, _hoisted_44)
                          ])
                        ], 2))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_45, [
                    (existingChampionsBtn.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: _normalizeClass(
                'px-[14px] py-[10px] text-white bg-[#155EEF] border border-[#155EEF] rounded-lg ' +
                (_unref(schoolStore).loading
                  ? 'cursor-not-allowed'
                  : 'cursor-pointer')
              ),
                          onClick: _withModifiers(saveExistingChampions, ["prevent"]),
                          disabled: 
                _unref(schoolStore).loading
              
                        }, [
                          _createElementVNode("h1", _hoisted_47, [
                            (
                    _unref(schoolStore).loading
                  )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                                  _createVNode(_component_spinner_loader, { color: 'text-white' }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t("internal_tools.form.btnSaving")), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(_ctx.$t("internal_tools.form.add_existing_champion")), 1))
                          ])
                        ], 10, _hoisted_46))
                      : _createCommentVNode("", true)
                  ]),
                  (updateSuccess.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("div", _hoisted_52, [
                            _createVNode(_unref(CheckCircleIcon), {
                              class: "h-5 w-5 text-green-400",
                              "aria-hidden": "true"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("p", _hoisted_54, _toDisplayString(responseMessage.value), 1)
                          ]),
                          _createElementVNode("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "inline-flex rounded-md bg-green-50 p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50",
                                onClick: closeSuccess
                              }, [
                                _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.$t("internal_tools.success.btnClose")), 1),
                                _createVNode(_unref(XMarkIcon), {
                                  class: "h-5 w-5",
                                  "aria-hidden": "true"
                                })
                              ])
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(LicenseManagement, {
                    school: (_unref(schoolStore).currentSchool as School)
                  }, null, 8, ["school"])
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_unref(TabPanel), {
                header: _ctx.$t('internal_tools.panel.class_details')
              }, {
                default: _withCtx(() => [
                  _createVNode(GradesClassesDetailsComponent)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_unref(TabPanel), {
                header: _ctx.$t('internal_tools.panel.teacher_details')
              }, {
                default: _withCtx(() => [
                  _createVNode(TeacherDetails, { class: "mt-6" })
                ]),
                _: 1
              }, 8, ["header"])
            ]),
            _: 1
          })
        ])),
    _createVNode(_unref(TransitionRoot), {
      appear: "",
      as: "template",
      show: showModal.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-40",
          onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.open = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_58
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("div", _hoisted_60, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _hoisted_61,
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg font-semibold leading-6 text-[#101828]"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.confirm_date.title")) + " " + _toDisplayString(_ctx.$t("global.grade_naming_convention")) + " " + _toDisplayString(_ctx.$t("rollover.modal.confirm_date.starting")) + " " + _toDisplayString(rolloverDate.value) + ".", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.text")) + ". ", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "whitespace-nowrap font-medium rounded-lg w-full py-2 px-6 btn-outline-red text-[#FDA29B] border border-[#FDA29B]",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (showModal.value = false))
                          }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.change")), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "whitespace-nowrap font-medium py-2 px-6 btn-red bg-[#FDA29B] text-white rounded-lg w-full",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (showModal.value = false))
                          }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.date_correct")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("p", _hoisted_67, [
                            _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.confirm_date.not_ready")) + "? ", 1),
                            _createElementVNode("span", {
                              class: "text-[#FDA29B]",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (showModal.value = false))
                            }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.confirm_later")), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(TransitionRoot), {
      appear: "",
      as: "template",
      show: confirmRolloverDateModal.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-40",
          onClose: _cache[27] || (_cache[27] = ($event: any) => (confirmRolloverDateModal.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_68
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _hoisted_71,
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg font-semibold leading-6 text-[#101828]"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.confirm_date.title")) + " " + _toDisplayString(_ctx.$t("global.grade_naming_convention")) + " " + _toDisplayString(_ctx.$t("rollover.modal.confirm_date.starting")) + " ", 1),
                                (newRolloverDate.value)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(newRolloverDate.value), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(rolloverDate.value), 1)),
                                _createTextVNode(". ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_75, [
                            _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.text")) + ". ", 1)
                          ])
                        ]),
                        (isCalendarHidden.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                              _createElementVNode("pre", _hoisted_78, _toDisplayString(_unref(rolloverStore).rollover?.rolloverDate) + " ", 1),
                              _createVNode(_component_FormKit, {
                                type: "form",
                                actions: false
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_FormKit, {
                                    type: "date",
                                    label: "Select new date",
                                    "label-class": "text-[#344054] font-medium text-sm mb-1.5",
                                    "outer-class": "primary-select label-bold mt-6",
                                    modelValue: newRolloverDate.value,
                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((newRolloverDate).value = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_79, [
                          (!isCalendarHidden.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "whitespace-nowrap font-medium rounded-lg w-full py-2 px-6 btn-outline-red text-[#FDA29B] border border-[#FDA29B]",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (isCalendarHidden.value = true))
                              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.change")), 1))
                            : _createCommentVNode("", true),
                          (!isCalendarHidden.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: _cache[23] || (_cache[23] = ($event: any) => (confirmDates())),
                                type: "button",
                                class: "whitespace-nowrap rounded-lg w-full font-medium py-2 px-6 btn-red bg-[#FDA29B] text-white"
                              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.date_correct")), 1))
                            : _createCommentVNode("", true),
                          (isCalendarHidden.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                type: "button",
                                class: "whitespace-nowrap font-medium py-2 px-6 btn-outline-red text-[#FDA29B] border border-[#FDA29B]",
                                onClick: _cache[24] || (_cache[24] = ($event: any) => (isCalendarHidden.value = false))
                              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.cancel")), 1))
                            : _createCommentVNode("", true),
                          (isCalendarHidden.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (confirmDates())),
                                type: "button",
                                class: "whitespace-nowrap font-medium py-2 px-6 btn-red bg-[#FDA29B] text-white"
                              }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.confirm_dates")), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_80, [
                          _createElementVNode("p", _hoisted_81, [
                            _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.confirm_date.not_ready")) + "? ", 1),
                            _createElementVNode("span", {
                              class: "text-[#FDA29B]",
                              onClick: _cache[26] || (_cache[26] = ($event: any) => (confirmDates()))
                            }, _toDisplayString(_ctx.$t("rollover.modal.confirm_date.confirm_later")), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(TransitionRoot), {
      appear: "",
      as: "template",
      show: completeRolloverModal.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-40",
          onClose: _cache[30] || (_cache[30] = ($event: any) => (completeRolloverModal.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_82
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_83, [
              _createElementVNode("div", _hoisted_84, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "p-8 relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("button", {
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (completeRolloverModal.value = false)),
                            class: "absolute top-4 right-4 focus-within:outline-none"
                          }, _hoisted_86),
                          _hoisted_87,
                          _createElementVNode("div", _hoisted_88, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg font-semibold leading-6 text-[#101828]"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("rollover.modal.success.title")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_89, [
                            _createElementVNode("p", _hoisted_90, _toDisplayString(_ctx.$t("rollover.modal.success.text")), 1)
                          ]),
                          _createElementVNode("button", {
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (confirmRolloverComplete())),
                            type: "button",
                            class: "bg-[#155EEF] rounded-lg p-2.5 text-base shadow-lg text-white mt-6 flex flex-row justify-center items-center flex-wrap mx-auto"
                          }, _toDisplayString(_ctx.$t("rollover.modal.success.confirm")), 1)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: confirmChampionDeletionModal.value,
      onLocalModalOpen: _cache[33] || (_cache[33] = ($event: any) => (confirmChampionDeletionModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createVNode(_unref(TrashIcon), { class: "h-6 w-6" })
            ])
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createVNode(_unref(DialogTitle), {
              as: "h3",
              class: "text-lg font-semibold text-[##101828] mb-1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_title")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("p", _hoisted_96, _toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_text")) + ". ", 1)
          ]),
          _createElementVNode("div", _hoisted_97, [
            _createElementVNode("button", {
              type: "button",
              class: "text-[#344054] border border-[#D0D5DD] text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (canceldeletion()))
            }, _toDisplayString(_ctx.$t("internal_tools.school_champions.modal.back")), 1),
            _createElementVNode("button", {
              type: "button",
              class: "text-white border border-[#155EEF] bg-[#155EEF] text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
              onClick: _cache[32] || (_cache[32] = ($event: any) => (adminToDelete.value && removeExistingChampion(adminToDelete.value, $event)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t("internal_tools.school_champions.modal.confirm_btn")) + " ", 1),
              (_unref(adminStore).loader.deleteAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                    _createVNode(_component_spinner_loader)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})